import cls from './Hooks.module.scss';
import legOneImg from '../../assets/images/leg_1.svg';
import anchorOneImg from '../../assets/images/anchor_1.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setIsAnchorTrue, setIsLegFalse, setIsLegTrue } from '../../redux/hooks/slice';
import { RootState } from '../../redux/store';
import { Pages } from '../../redux/pages/types';
import { useRef } from 'react';

const Hooks = () => {
  const { leg_count, anchor_count } = useSelector((state: RootState) => state.hooks);
  const { endGame, currentPage } = useSelector((state: RootState) => state.pages);
  const dispatch = useDispatch();

  const onClickLeg = () => {
    if (!endGame && currentPage === Pages.GAME) {
      dispatch(setIsLegTrue());
      setTimeout(() => {
        dispatch(setIsLegFalse());
      }, 3000);
    }
  };

  const functionCalled = useRef(false);

  const onClickAnchor = (
    ev: React.TouchEvent<HTMLImageElement> | React.MouseEvent<HTMLImageElement, MouseEvent>,
  ) => {
    if (functionCalled.current) return;
    functionCalled.current = true;

    if (!endGame && currentPage === Pages.GAME) {
      functionCalled.current = true;
      dispatch(setIsAnchorTrue());
    }

    setTimeout(() => {
      functionCalled.current = false; // сброс флага
    }, 5001);
  };

  return (
    <div className={cls.hooks}>
      <div className={cls.hookItem} onClick={() => onClickLeg()}>
        {leg_count === 0 ? (
          <img alt="Leg" src={legOneImg} className={cls.leg} />
        ) : (
          <img alt="Leg" src={legOneImg} className={cls.leg} />
        )}
        <h2>x{leg_count}</h2>
      </div>
      <div className={cls.hookItem}>
        {anchor_count === 0 ? (
          <img
            alt="Anchor"
            src={anchorOneImg}
            onTouchStart={(ev) => onClickAnchor(ev)}
            onClick={(ev) => onClickAnchor(ev)}
          />
        ) : (
          <img
            alt="Anchor"
            src={anchorOneImg}
            onTouchStart={(ev) => onClickAnchor(ev)}
            onClick={(ev) => onClickAnchor(ev)}
          />
        )}
        <h2>x{anchor_count}</h2>
      </div>
    </div>
  );
};

export default Hooks;
